import { submitToOpenApi } from '@wellbeingxltd/fe-lib/api/dist'
import { OLD_URL, URL } from './endpoints'

export const ACTIONS = {
    GET_CLIENT_LOGIN_CONFIG: {
        START: 'GET_CLIENT_LOGIN_CONFIG START',
        SUCCESS: 'GET_CLIENT_LOGIN_CONFIG SUCCESS',
        FAILURE: 'GET_CLIENT_LOGIN_CONFIG FAILURE',
    },
    CLEAR_CLIENT_LOGIN_CONFIG: 'CLEAR_CLIENT_LOGIN_CONFIG',

    REQUEST_INVITATION_CODE: 'REQUEST_INVITATION_CODE',
    SET_LOGIN_START: 'SET_LOGIN_START',
    SET_LOGIN: 'SET_LOGIN',
    SET_LOGOUT: 'SET_LOGOUT',
    SET_LOGIN_STATE: 'SET_LOGIN_STATE',
    SET_EMAIL: 'SET_EMAIL',
    SET_PASSWORD: 'SET_PASSWORD',
    SET_PHONE: 'SET_PHONE',
    TOGGLE_SPINNER: 'TOGGLE_SPINNER',
}

export const getClientLoginConfig = companyNickname => async dispatch => {
    dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.START })
    try {
        const resp = await submitToOpenApi({
            path: OLD_URL.V2_CLIENTS_SETUP, // TODO BS-222
            query: { companyNickname },
            url: URL.CLIENTS.BASE,
        })
        const data = resp
        window.localStorage.setItem('loginConfig', JSON.stringify(data))
        dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.SUCCESS, data: data })
    } catch (error) {
        dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.FAILURE, error })
    }
}

export const clearClientLoginConfig = () => dispatch => {
    window.localStorage.removeItem('loginConfig')
    dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.SUCCESS, data: null })
}
export const setClientLoginConfig = data => dispatch => {
    dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.SUCCESS, data })
}
export const setClientLoginConfigError = error => dispatch => dispatch({ type: ACTIONS.GET_CLIENT_LOGIN_CONFIG.FAILURE, error })

export const requestInvitationCode =
    (body, successCallback = () => {}, errorCallback = () => {}) =>
    async () => {
        try {
            const res = await submitToOpenApi({
                body,
                method: 'POST',
                path: OLD_URL.PROFILE.TEMPLATE_REQUEST_INVITATION,
                url: URL.USER_PROFILES.BASE,
            })
            successCallback(res)
        } catch (error) {
            errorCallback(error)
        }
    }

export const toggleSpinner = data => dispatch => dispatch({ type: ACTIONS.TOGGLE_SPINNER, data })

export const setLoginStart = data => dispatch => dispatch({ type: ACTIONS.SET_LOGIN_START, data })

export const setEmail = data => dispatch => {
    dispatch({ type: ACTIONS.SET_EMAIL, data })
    window.localStorage.setItem('email', data)
}

export const setPassword = data => dispatch => {
    dispatch({ type: ACTIONS.SET_PASSWORD, data })
    window.localStorage.setItem('password', data)
}

export const setPhone = data => dispatch => dispatch({ type: ACTIONS.SET_PHONE, data })

export const setLogin = data => dispatch => dispatch({ type: ACTIONS.SET_LOGIN, data })

export const setLogout =
    (successCallback = () => {}) =>
    dispatch => {
        dispatch({ type: ACTIONS.SET_LOGOUT })
        successCallback()
    }

export const setLoginState = data => dispatch => dispatch({ type: ACTIONS.SET_LOGIN_STATE, data })
